import React, { useEffect, useRef, useState } from "react";
import "./FollowCursor.css"; // Import the CSS file

// Utility function to check for Safari browser
const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome"); // Safari user agent contains "safari" but not "chrome"
};

const FollowCursor = () => {
  const circleRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

  // Update the mobile state when window width changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isSafari() || isMobile) {
      return;
    }

    const handleMouseMove = (e) => {
      if (circleRef.current) {
        circleRef.current.style.setProperty("--x", `${e.clientX}px`);
        circleRef.current.style.setProperty("--y", `${e.clientY}px`);
      }
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isMobile]);

  return <div className="circle-mouse" ref={circleRef}></div>;
};

export default FollowCursor;
